export default __webpack_public_path__ + "static/O0270-6002ae9c5405af659e3cdc200768311d.png";